export const bugReportId = 'bugReport';
export const nameIssueId = 'bugNameId';
export const serviceClassesId = 'bugServiceClassesId';
export const issueDiscriptionId = 'bugDiscriptionId';
export const solutionIssueId = 'solutionOfBubId';
export const uploaderFilesId = 'uploaderFilesId';
